import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterTableDataAPI } from "services/CRUDServices"
import { getUrls } from "services/api.enums"

export const filterPaymentManagement: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "payment-managemnt",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      getUrls.PaymentManagemnt,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )


    return data.data.payload
  }
)

const initialState: any = {
  paymentdata: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const PaymentManagemntSlice = createSlice({
  initialState: initialState,
  name: "payment-managemnt",
  reducers: {
    clearPaymentdata: (state) => {
      state.paymentdata = []
    },
    setPaymentFilter: (state, action) => {
      state.filter = action.payload
    },

  },
  extraReducers: {
    [filterPaymentManagement.fulfilled as any]: (state, action) => {
      state.paymentdata = action.payload
      state.fetchpost = false
    },
    [filterPaymentManagement.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterPaymentManagement.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setPaymentFilter, clearPaymentdata} =
  PaymentManagemntSlice.actions
export default PaymentManagemntSlice.reducer
